/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Fields,
  FieldsToSchema,
  FieldStructure,
  FormFieldsStructure,
} from '@local-types';
import { isFunction } from 'lodash';
import { object } from 'yup';
import { ObjectShape } from 'yup/lib/object';

export const getFormDefaultValues = <T extends FormFieldsStructure>(
  fields: T
): Fields<T> => {
  const defaultValues = Object.entries(fields).reduce((acc, [_, field]) => {
    // @ts-expect-error acc key missing
    acc[field.path] = field.defaultValue ?? null;
    return acc;
  }, {} as Fields<T>);

  return defaultValues;
};

export const getFormWithValues = <T extends FormFieldsStructure>(
  fields: T,
  values: Partial<Fields<T>>
): Fields<T> => {
  const defaultValues = getFormDefaultValues(fields);

  return { ...defaultValues, ...values };
};

export const generateSchemaFromFields = <T extends FormFieldsStructure>(
  fields: T,
  customParams:
    | Record<string, any>
    | ((field: FieldStructure) => Record<string, any>) = {}
) => {
  const rules = Object.entries(fields).reduce((acc, [_, field]) => {
    if (field.rule) {
      acc[field.path] = isFunction(field.rule)
        ? isFunction(customParams)
          ? field.rule(customParams(field))
          : field.rule(customParams)
        : field.rule;
    }
    return acc;
  }, {} as ObjectShape);

  return object().shape(rules) as FieldsToSchema<T>;
};
